import { BaseDto } from './base-dto';

export class Login extends BaseDto {
    public UserName!: string;
    public Pwd!: string;
}
